import React, { useRef } from 'react';
import { Tooltip } from '@mui/material';

import { ReactComponent as AttachmentIcon } from 'assets/attachment.icon.svg';
import { tt } from '@i18n/tt';

interface IProps {
  onFileSelection: (file: File) => void;
}

const FileSelector: React.FC<IProps> = ({ onFileSelection }) => {
  const ref = useRef<HTMLInputElement>(null);

  const onClick = (): void => {
    ref?.current?.click();
  };

  return (
    <>
      <Tooltip title={tt('common.attachFile')}>
        <AttachmentIcon onClick={onClick} style={{ cursor: 'pointer' }} />
      </Tooltip>
      <input
        type="file"
        ref={ref}
        style={{ display: 'none' }}
        onChange={e => {
          if (e.target.files && e.target.files.length) {
            onFileSelection(e.target.files[0]);
          }
        }}
      />
    </>
  );
};

export default FileSelector;
